import { render, staticRenderFns } from "./tasting-card.vue?vue&type=template&id=bdf41840&scoped=true&"
import script from "./tasting-card.vue?vue&type=script&lang=js&"
export * from "./tasting-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf41840",
  null
  
)

export default component.exports